import React from 'react';
import T from 'prop-types';
import { Button } from '@acast/decibel';
import { PlusLightGlyph, MinusLightGlyph } from '@acast/decibel-glyphs';

const createDecreaseHandler = zoom => () => zoom(-1);
const createIncreaseHandler = zoom => () => zoom(1);

const WaveformZoomControl = ({ zoomLevel, onZoom }) => (
  <div className="editor-controls__item-container zoom-controls">
    <Button
      size="small"
      variant="secondary"
      glyph={MinusLightGlyph}
      onClick={createDecreaseHandler(onZoom)}
    />
    <div className="zoom-level">{zoomLevel}%</div>
    <Button
      size="small"
      variant="secondary"
      glyph={PlusLightGlyph}
      onClick={createIncreaseHandler(onZoom)}
    />
  </div>
);

WaveformZoomControl.propTypes = {
  zoomLevel: T.number.isRequired,
  onZoom: T.func.isRequired,
};

export default WaveformZoomControl;
